export interface NotificationDetailProps {
  data: NotiDataType
  onClose: () => void
}

export interface NotificationProps {
  openConfirmModal: boolean;
  action: string;
  data: NotiDataType[];
  dataDetail: NotiDataType
}

export interface MenuActionProps {
  onClear: () => void;
  onClose: () => void;
}

export interface NotificationViewAllProps {
  data: NotiDataType[]
  onClose: () => void
}


export enum NotificationType {
  SECURITY = 0,
  MESSAGE = 1,
  GIFT = 2,
  TRAVEL_RULE = 3,
}

export interface NotiDataType {
  id: string;
  type: number;
  title: string;
  content: string;
  read: boolean;
  time: Date;
  actionType?: 'travel_rule' | 'link';
  actionPayload?: string;
}